import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#00CB14",
  d: "M17.05 29.1 31.2 14.95l-2.3-2.25-11.85 11.85-6-6L8.8 20.8l8.25 8.3ZM20 40c-2.733 0-5.317-.525-7.75-1.575-2.433-1.05-4.558-2.483-6.375-4.3-1.817-1.817-3.25-3.942-4.3-6.375C.525 25.317 0 22.733 0 20c0-2.767.525-5.367 1.575-7.8 1.05-2.433 2.483-4.55 4.3-6.35 1.817-1.8 3.942-3.225 6.375-4.275C14.683.525 17.267 0 20 0c2.767 0 5.367.525 7.8 1.575 2.433 1.05 4.55 2.475 6.35 4.275 1.8 1.8 3.225 3.917 4.275 6.35C39.475 14.633 40 17.233 40 20c0 2.733-.525 5.317-1.575 7.75-1.05 2.433-2.475 4.558-4.275 6.375-1.8 1.817-3.917 3.25-6.35 4.3C25.367 39.475 22.767 40 20 40Zm0-3c4.733 0 8.75-1.658 12.05-4.975C35.35 28.708 37 24.7 37 20c0-4.733-1.65-8.75-4.95-12.05C28.75 4.65 24.733 3 20 3c-4.7 0-8.708 1.65-12.025 4.95C4.658 11.25 3 15.267 3 20c0 4.7 1.658 8.708 4.975 12.025C11.292 35.342 15.3 37 20 37Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };